var _rect, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocationGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821",
    transform: "translate(-4811.367 -2594.475)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4499",
    "data-name": "Rectangle 4499",
    width: 24,
    height: 24,
    transform: "translate(4811.367 2594.475)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(4752.239 2597.467)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5792",
    "data-name": "Path 5792",
    d: "M71.168,18.344l-3.411-3.4L64.9,10.028l-.389-2.152.2-1.706,1.022-2.535,2.015-1.9,2.4-.666h2.322l1.37.426,1.314.82,1.922,2.99.367,1.78-.206,1.8-1.19,2.719-2.39,3.529Z",
    transform: "translate(0.147 -0.336)",
    fill: "#65676a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11824",
    "data-name": "Group 11824",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11823",
    "data-name": "Group 11823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M71.128,0A7.135,7.135,0,0,0,64,7.128c0,4.941,6.434,11.432,6.707,11.706a.6.6,0,0,0,.841,0c.273-.274,6.707-6.766,6.707-11.706A7.135,7.135,0,0,0,71.128,0Zm0,17.555c-1.418-1.518-5.94-6.653-5.94-10.427a5.94,5.94,0,0,1,11.88,0C77.068,10.9,72.546,16.037,71.128,17.555Z",
    transform: "translate(-64)",
    fill: "#65676a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11826",
    "data-name": "Group 11826",
    transform: "translate(67.564 3.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11825",
    "data-name": "Group 11825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M163.564,96a3.564,3.564,0,1,0,3.564,3.564A3.568,3.568,0,0,0,163.564,96Zm0,5.94a2.376,2.376,0,1,1,2.376-2.376A2.378,2.378,0,0,1,163.564,101.94Z",
    transform: "translate(-160 -96)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationGray);
export default __webpack_public_path__ + "static/media/icon_location_gray.47a282e190f2692f83b43f49cd9e50c2.svg";
export { ForwardRef as ReactComponent };